export default __webpack_public_path__ + "static/media/appOnPhone.a6ec8cf5.png";